<template>
  <div class="overlay">
    <div class="overlay-dialog">
      <h3 class="overlay-dialog-title">Zákonná přestávka</h3>
      <p style="width:80%;">
        Je nám líto, ale tuto akci není možné provést. Dosáhli jste zákonného limitu hraní 120 minut bez přerušení.
        Pokračovat ve hře za reálné peníze můžete za: {{displayedTime | convertTimeFilter}}. Do té doby můžete zkusit DEMO verzi hry.
      </p>
    </div>
  </div>
</template>

<script>
import convertTimeFilter from '@/mixins/filterTime';

export default {
  name: 'CZRegulatoryOverlay',
  mixins: [convertTimeFilter],
  props: { displayedTime: { type: [String, Number], required: true } }
}
</script>

<style lang="scss" scoped>
  .overlay {
    position: absolute;
    top: 30px;
    left: 0;
    height: calc(100% - 60px);
    width: 100%;
    background-color: rgba(100, 100, 100, 0.25);
    z-index: 1000;

    &-dialog {
      display: flex;
      justify-content: center;
      flex-direction: column;
      position: absolute;
      align-items: center;
      text-align: center;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 600px;
      max-height: 400px;
      width: 90%;
      height: 40%;
      padding: 0 20px;
      background-color: #2c2c2c;
      color: white;
      box-shadow: 10px 10px 30px -15px rgba(0,0,0,0.75);

      &-title {
        width: 90%;
        padding-bottom: 20px;
        border-bottom: 1px solid #c9c6ba;
        font-weight: bold;
        font-size: 26px;
      }
    }
  }
</style>